module.exports = new __parcel__URL__("buckley-listening.1dbf5142.png").toString();